module.exports = __webpack_public_path__ + "img/seesaw_logo.38c9ff1.png";